import React from 'react';
import styled from 'styled-components';
import QuillRichtextDisplay from 'components/QuillRichtextDisplay';

const DescriptionContainer = styled.div`
  position: relative;
  line-height: 24px;
  overflow: auto;
  max-height: 100%;
  max-width: 100%;
  flex-grow: 1;
  margin-block-start: 0;
  margin-block-end: 0;
  text-overflow: ellipsis;
  word-break: break-word;
  padding: 0;
  font-size: 0.875rem;

  & p {
    margin-block-start: 0;
    margin-block-end: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
`;

const BannerRichText = ({
  htmlContent,
}: {
  htmlContent: string;
}) => (
  <DescriptionContainer className="ql-editor">
    <QuillRichtextDisplay html={htmlContent} />
  </DescriptionContainer>
);

export default BannerRichText;
